<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的车辆信息：</span>
    </div>
    <div class="checkYS">
      <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px"/>
      <Select v-model="carCorlor" placeholder="车牌颜色" style="width: 200px;margin-left: 5px">
        <Option v-for="(item,index) in colorType" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultThree">{{resultThree}}</div>
  </div>
</template>
<script>
  import {apiGet} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkCN',
    data() {
      return {
        carNum: '',
        carCorlor: '',
        resultThree: '',
        colorType: [
          {
            value: 1,
            label: "蓝牌"
          },
          {
            value: 2,
            label: "黄牌"
          },
          {
            value: 3,
            label: "绿牌"
          }
        ],
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.carNum || !this.carCorlor) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后将付费查询").then((type) => {
          if (type === "confirm") {
            this.vQueryRTCNo();
          }
        });
      },
      async vQueryRTCNo() {
        let params = {
          method: 'vQueryRTCNo',
          params: {
            vno: this.carNum,
            vco: this.carCorlor
          }
        }
        showLoading();
        let res = await apiGet("api/order/track/", params.method, params.params);
        hideLoading();
        if (res.status === 1) {
          let resData = JSON.parse(res.data)
          if (resData.status === 1001) {
            let data = resData.result;
            let roadTransport = data.roadTransport;
            let vdtTm = data.vdtTm;
            if (roadTransport != null && roadTransport.length > 0) {
              this.resultThree = "道路运输证号码：" + roadTransport + '\n' + '有效期：' + vdtTm;
            } else {
              this.resultThree = "无结果";
            }
          } else if (resData.status === 1006) {
            this.resultThree = "无结果";
          } else {
            this.resultThree = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
    }
  }
</script>
<style scoped>
  .checkYS {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultThree {
    height: 20%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
    white-space: pre;
  }
</style>